import React from 'react';
import PropTypes from 'prop-types';

const DimensionDisplayName = ({ dimension: { displayName }, isActive }) => (
  <>
    <span style={{ color: isActive ? '#34a835' : '#e91224' }}>
      <i className="pi pi-circle-on" />
      {displayName}
    </span>
  </>
);

DimensionDisplayName.propTypes = {
  isActive: PropTypes.bool.isRequired,
  displayName: PropTypes.string.isRequired,
  dimension: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default DimensionDisplayName;
